import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  buttonSize: 'sm'
} satisfies RecursivePartial<DialogConfig['notifyMe']>
